<template>
  <div>
    <div class="grid-content maintitle">
      <span>员工管理</span>
    </div>
    <buttonarea :iscreate='config.hascreate' @createTarget='createTarget' @refresh='refresh'>
        <importFile url="/manage/staff/importstafflist?appid=188" methods="post"
          downloadFileurl="/manage/staff/importstaffreport?appid=188"></importFile>
        <exportFile url="/manage/staff/exportstafflist?appid=188" methods="post" :sendData='sendData'></exportFile>
      <el-button size="medium" round @click="downTemplate">下载模板</el-button>
    </buttonarea>
      <!-- 筛选栏开始 -->
    <div class="grid-content content-margin search-style">
        <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">员工编号</span>
          </td>
          <td>
            <el-input clearable prefix-icon="el-icon-search" v-model="sendData.filterConfig.workNo" size="small"
               placeholder="员工编号" />
          </td>
          <td style="padding-left: 20px;">
            <span class="simpleLabel">员工姓名</span>
          </td>
          <td>
            <el-input clearable prefix-icon="el-icon-search" v-model="sendData.filterConfig.name" size="small"
              placeholder="员工姓名" />
          </td>
          <td>
            <span class="simpleLabel">手机号</span>
          </td>
          <td>
            <el-input clearable prefix-icon="el-icon-search" v-model="sendData.filterConfig.mobile" size="small"
              placeholder="手机号" />
          </td>
           <!-- <td>
              <el-button size="small" @click="refresh"> 搜索</el-button>
            </td>
            <td>
              <el-button size="small" @click="clear"> 清空</el-button>
            </td> -->
        </tr>
      </table>
           <!-- 筛选按钮开始 -->
           <div class="search-button"> 
            <div style="flex:0 0 80px;text-align:right"> </div>
            <div style="display:flex;">
              <el-button type="primary" @click="refresh" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini" icon="el-icon-search">检索</el-button>
              <el-button type="danger"  @click="clear" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini"  icon="el-icon-delete">清除</el-button>
            </div>
        </div>
            <!-- 筛选按钮结束 -->
      </div>
      <!-- 筛选栏结束 -->

     <div class="grid-content content-margin">
      <el-table ref="table" :data="articleList" stripe border :height="tableHeight" style="width: 100%"
        @sort-change="filterFunc">
        <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" round type="normal" icon="el-icon-zoom-in" @click="editTarget(scope.row, false)">
              </el-button>
              <el-button size="mini" round type="normal" icon="el-icon-edit" @click="editTarget(scope.row, true)">
              </el-button>
              <el-button size="mini" round type="normal" icon="el-icon-delete" @click="
                      targetRow = scope.row;
                deleteDialogVisible = true;
              "></el-button>
            </el-button-group>
          </template>
        </el-table-column>

        <el-table-column prop="workno" :label="$t('message.员工编号')" min-width="150" align="center">
        </el-table-column>

        <!-- <el-table-column prop="name" :label="$t('message.员工姓名')" style="min-width: 250px;"> -->
        <el-table-column prop="name" :label="$t('message.员工姓名')" min-width="150" align="center">
        </el-table-column>
        <el-table-column sortable :label="$t('message.职位')" prop="position" min-width="150" align="center">
          <!-- <template slot-scope="scope">
            <span>{{ $t(`${getposition(scope.row.position)}`) }}</span>
          </template> -->
        </el-table-column>
        <el-table-column sortable :label="$t('message.禁用状态')" prop="state" min-width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.state==1?'禁用':scope.row.state==0?'正常':'删除' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('message.手机')" width="200px" align="center">
        </el-table-column>
        <el-table-column width="120" sortable :label="$t('message.关联门店')" prop="currentshopid" align="center">
          <template slot-scope="scope">
            <span>{{ hashidtoname[scope.row.currentshopid] }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="createdate" :label="$t('message.更新日期')" width="200" align="center">
          <template slot-scope="scope">
            {{setdate(scope.row.createdate)}}
          </template>
        </el-table-column>
        <el-table-column sortable prop="editdate" :label="$t('message.编辑日期')" width="200" align="center">
          <template slot-scope="scope">
            {{ setdate(scope.row.editdate)}}
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagesizeList='pageConfig.pagesizeList' :pagesize='sendData.pageConfig.pagesize'
        :total='sendData.pageConfig.total' :page='sendData.pageConfig.page'></pagination>
    </div>
   <el-dialog :title="$t('message.删除确认')" :visible.sync="deleteDialogVisible" width="300px" :modal="false" center
      :before-close="handleClose">
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
        $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
        $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
    <modalreal :zIndexEdit='true' :width='900' :height='750' v-if="showmodal">
      <div slot="title">
        <div v-if="isEditMode&&!isEditMode2"> 添加员工</div>
        <div v-if="!isEditMode"> 员工详情</div>
        <div v-if="isEditMode&&isEditMode2"> 编辑员工</div>
      </div>
      <div style="flex:1" slot="contner">
        <div class="grid-content content-margin">
          <table class="simpleRow">
            <template v-for="(item,index) in storecountdata">
              <tr v-if="item.type!=15">
                <td>
                  <span class="simpleLabel">{{item.label}}</span>
                </td>
                <td v-if="item.type==0">
                  <span class="readonly" @input="int(item.value)" :readonly="item.type==0" size="mini"
                  :placeholder="item.label" :disabled='!isEditMode'>{{datashowtrans(item)}}</span>
                </td>
                <td v-if="item.type==1||item.type==5">
                  <el-input   @change="myFunction1()" :readonly="item.type==0" v-model="item.value" size="mini"
                  :placeholder="item.label" :disabled='!isEditMode'/>
                </td>
                        <span v-if="showtip1&&item.key=='workNo'" style="color:red">错误:员工编号已被{{ changeForm.name }}占用
                            <span @click="pushnew" style="color:blue">(查看)</span>
                        </span>
                         <!-- <span v-if="showtip2&&item.key=='mobile'" style="color:red">错误：该员工的手机号已经被{{ changeForm.name }}占用
                            <span @click="pushnew" style="color:blue">(查看)</span>
                        </span> -->
                <td v-if="item.type==2">
                   <el-input   @change="myFunction2()" :readonly="item.type==0" v-model="item.value" size="mini"
                  :placeholder="item.label" :disabled='!isEditMode'/>
                </td>
                 <span v-if="showtip2&&item.key=='mobile'" style="color:red">错误:员工手机号已被{{ changeForm.name }}占用
                            <span @click="pushnew" style="color:blue">(查看)</span>
                        </span>
                <td v-if="item.type==3">
                  <el-date-picker :disabled='!isEditMode' @input="int(item.value)" type="date" value-format='timestamp' v-model="item.value" :placeholder="$t('message.选择日期时间')" size="mini"></el-date-picker>
                </td>
                <td v-if="item.type==4">
                  <div @click="doShowResourceStore(index,'rewardedittable')" :class="false?'unsel-img-box fff':'sel-img-box fff'">
                    <i class="iconfont" v-if="!item.value">&#xe727;</i>
                    <el-popover placement="right" trigger="hover" v-else>
                      <img :src="'' + item.value" alt="" style="max-width: 500px;max-height: 500px">
                      <img slot="reference" :src="'' + item.value">
                      <el-button v-if="true" type="danger" icon="el-icon-delete" circle @click.native="item.value = '';displayvisible = true;
        displayvisible = false"></el-button>
                    </el-popover>
                  </div>
                </td>
                <td v-if="item.type==5&&item.value">
                  <span class="tag">{{item.value}}</span>
                </td>
                <td v-if="item.type==6">
                  <el-input :disabled='!isEditMode' @input="int(item.value)" :readonly="!isEditMode" size="mini" class="linkTextArea"
                   v-model="item.value" type="textarea" :placeholder="员工编号"  show-word-limit />
                </td>
                <td v-if="item.type==7&&(!item.relate||arrivecondition[index+item.relate].value==4)">
                  <div v-if="item.iscnm">
                    <el-input-number :disabled='!isEditMode' @input="displayvisible = true;displayvisible = false;item.value=item.othervalue*1000" :readonly="!isEditMode" size="mini" :min="0" :max="100" v-model="item.othervalue" :precison='3' step-strictly :step='0.001' :value="0" />
                    <el-input-number :disabled='!isEditMode' v-show="false" @input="int(item.value);" :readonly="!isEditMode" size="mini" :min="0" v-model="item.value" />
                  </div>
                  <el-input-number :disabled='!isEditMode' v-else @input="int(item.value);" :readonly="!isEditMode" size="mini" :min="0" :step-strictly='item.step' v-model="item.value" />
                  <span v-if="item.remark">{{'备注'+item.remark}}</span>
                </td>
                <td v-if="item.type==8">
                  <el-button :disabled='!isEditMode' @click="showv(index,'rewardedittable')" size="mini">{{item.value==undefined?'设置条件表达式':'修改条件表达式'}}</el-button>
                  <el-button @click="iscondelet('rewardedittable',index)" :disabled='!isEditMode' type='danger' size="mini">清除</el-button>
                </td>
                <td v-if="item.type==9">
                  <el-button :disabled='!isEditMode' @click="openbook(index)" size="mini">预约配置</el-button>
                </td>
                <td v-if="item.type==11">
                  <el-input :disabled='!isEditMode' v-model="item.value" @change="item.value=item.value-0" size="mini" @input="int(item.value)"></el-input>
                </td>
                <td v-if="item.type==12">
                  <el-select :disabled='!isEditMode' v-model="item.value" :placeholder="$t('message.请选择')" @change="changeoption(index,item.value)">
                    <el-option v-for="(it,index) in item.selectarr" :key="index" :label="it.key" :value="it.value">
                    </el-option>
                  </el-select>
                </td>
                <td v-if="item.type==13">
                  <el-switch :disabled='!isEditMode' v-model="item.value" :active-text="item.selectarr[1].key" :active-value='item.selectarr[1].value' :inactive-value='item.selectarr[0].value' :inactive-text="item.selectarr[0].key" @change="int">
                  </el-switch>
                </td>
                <td v-if="item.type==14">
                        <!-- <el-autocomplete  v-model="shopname"
                            :fetch-suggestions="getshoplist" :disabled="!isEditMode" placeholder="请输入门店"
                            @select="handleSelect">
                            <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick">
                            </i>
                            <template slot-scope="{item}">
                                <div class="name">{{ item.name }}</div>
                               
                            </template>
                          </el-autocomplete> -->

                         <!-- <span class="addr">{{ item.shopid }}</span> -->

                        <el-select v-model="storecountdata[4].value" filterable placeholder="请输入门店"  :disabled="!isEditMode">
                            <el-option
                              v-for="item in myshoplist"
                              :key="item.shopid"
                              :label="item.name"
                              :value="item.shopid">
                            </el-option>
                        </el-select>


                   </td>
                <td v-if="item.type==15">
                        <el-select v-model="item.position" placeholder="请选择你的职位" :disabled="!isEditMode">
                            <el-option label="店员" value="店员"></el-option>
                            <el-option label="店长" value="店长"></el-option>
                            <el-option label="区域主管" value="区域主管"></el-option>
                        </el-select>
                </td>
                 <td v-if="item.type==16">
                  <el-select :disabled='!isEditMode' v-model="item.value" :placeholder="$t('message.请选择')" @change="changeoption(index,item.value)">
                    <el-option v-for="(it,index) in item.selectarr" :key="index" :label="it.key" :value="it.value">
                    </el-option>
                  </el-select>
                </td>
                <td v-if="item.desc">
                  <span style="color:red">{{item.desc}}</span>
                </td>
              </tr>
            </template>

          </table>
        </div>
      </div>
      <div class="footer" slot="foter">
        <el-button @click="cancel(0)" size="mini">取消</el-button>
        <el-button @click="isEditMode=true" size="mini" v-if="!isEditMode">修改</el-button>
        <el-button @click="dosave(0)" type="primary" size="mini" v-else>保存</el-button>
      </div>
    </modalreal>

    <a :href="url" style="display: none" ref="aclick" ></a>
    <input type="file" accept="csv/*" multiple style="display: none" ref="uploadInp">
  </div>
</template>
<script>
  import buttonarea from '@/components/vipcom/buttonarea'
  import commonUtil from "@/utils/commonUtil";
  import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import { setarrdate, setdate, idturnname } from '@/utils/timerest'
  import modalreal from '@/components/modalCom/modalreal'
  import { confirmmy, idtoname, pushdata } from '@/utils/minxins'
  import pagination from "@/components/pagination/pagination";
  import importFile from "@/components/export-import/importFile";
  import exportFile from "@/components/export-import/exportFile";
  export default {
    name: 'shopmanagement',
    components: { buttonarea, modalreal,pagination,importFile,exportFile },
    data() {
      return {
        shoplist:[],  // 存放门店列表数据
        myshoplist:[],
        // shopvalue:{},
        showtip1:false, //员工编号提示开关
        showtip2:false, //手机错误提示开关
        articleList:[],
        shopname:'',
        csvTitle: '',
        tableHeight: 500,
        url: "",
        name:null,

      selectedTypeID: "",  //筛选条件  1编号 2手机 3职位
      search: "",
      deleteDialogVisible: false,
      hashidtoname: {},  //根据currentshopid查找门店名
      targetRow: null,
      pageConfig: {
        pagesizeList: [10, 20, 50, 100],
        pageSize: 10,
      },
      typeOptions: [
        {
          value: "1",
          label: this.$t('编号'),
        },
        {
          value: "2",
          label: this.$t('message.手机'),
        },
        {
          value: "3",
          label: this.$t('message.职位'),
        },
      ],
      setdate: setdate,
       //@change发送返回接口数据 改变后的表单数据
            changeForm:{
                name:null,
                mobile:'',
                staffid:''
            },

        url:'',
      pageConfig:{
        pagesizeList:[10,20,50,100],
        pageSize:10,
        total:0
      },
      sendData:{
        appID:188,
        filterConfig:{
          keyword:'',
          filterType: 0,
          keyword: "",
          name: null,
          shopNo: null,
          workNo:null,
          mobile:null
        },
        pageConfig:{
          page:1,
          pagesize:10,
          pageStartIndex:0,
        },
        sortConfig:{
          order:'',
          prop:''
        }
      },
        // 配置项
        config: {
          // 是否分页
          // 有新建
          hascreate: true,
          // 有编辑
          // 有删除
          // 有detail
        },
        tableHeight: 150,
        tableData: [],
        formatedata: {
          //   createdate: true,
          //   editdate: true,
          //   expirydate:true
        },
        // 配置项
        config: {
          // 是否分页
          ispagec: true,
          // 有新建
          hascreate: true,
          // 有编辑
          hasedit: true,
          // 有删除
          hasdelete: true,
          // 有detail
          hasdetail: true,
        },
        storecountdata: [
        {
          key: 'appID',
          label: 'appID',
          value: 188,
          type: 15,
          isrow: false,
        }, {
          key: 'staffid',
          label: '店员编号',
          value: undefined,
          type: 0,
          isrow: true,
        }, {
          key: 'name',
          label: '姓名',
          value: undefined,
          type: 6,
          isrow: true,
          //   checkname: {
          //    //只能输入中文和英文
          //    rule: /^[\u4EOO-\u9FA5A-Za-z]+$/
          // }
        }, {
          key: 'workNo',
          label: '员工编号',
          value: undefined,
          type: 1,
          isrow: true,
              //checkworkNo: {
             //只能输入英文和数字
            //  rule: /^[A-Za-z0-9]+$/
          //}
        }, {
          key: 'currentshopid',
          // label: '当前门店的id',
          label: '门店编号',
          value: undefined,
          type: 14,
          isrow: true,
        }, {
          key: 'mobile',
          label: '手机',
          value: undefined,
          type: 2,
          isrow: true,
          check: {
            // rule: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/
            rule: /^[1][3,4,5,6,7,8,9][0-9]{9}$/
          }
        }, {
          key: 'position',
          label: '职位',
          value: undefined,
          type: 12,
          isrow: true,
          selectarr: [{ key: '未分配', value: '未分配' },{ key: '员工', value: '员工' }, { key: '店长', value: '店长' }, { key: '区域主管', value: '区域主管' }],
        }, {
          key: 'state',
          label: '员工状态',
          value: undefined,
          type: 12,
          isrow: true,
          selectarr: [{ key: '正常', value:0}, { key: '禁用', value: 1 }, { key: '删除', value: 2 }],

        },  {
          key: 'miss',
          label: 'openID',
          value: undefined,
          type: 0,
          isrow: true,
        }, {
          key: 'miss',
          label: 'unionID',
          value: undefined,
          type: 0,
          isrow: false,
        }, {
          key: 'miss',
          label: '最后登录',
          value: undefined,
          type: 0,
          isrow: false,
          selectarr: [{ key: '正常', value: 0 }, { key: '已领完', value: 1 }, { key: '隐藏', value: 2 }],
        }, {
          key: 'createid',
          label: '创建者',
          value: undefined,
          type: 0,
          isrow: true,
        }, {
          key: 'createdate',
          label: '创建日期',
          value: undefined,
          type: 0,
          isrow: true,
        }, {
          key: 'editid',
          label: '编辑者',
          value: undefined,
          type: 0,
          isrow: true,
        }, {
          key: 'editdate',
          label: '编辑日期',
          value: undefined,
          type: 0,
          isrow: true,
        }, ],
        coordinatable: [],
        // 展示模态框
        showmodal: false,
        // 是编辑模式
        isEditMode: false,
        isEditMode2: false,
        // 是新增
        isInit: false,
        showmodal2: false,
        funccoor: null,
        coortableindex: -1,
        setdate: setdate,
        idnamemap: {}
      }
    },
    // watch:{
    //   shopvalue(newvalue,oldvalue) {
    //     console.log(newvalue,oldvalue,'111111111')
    //     this.shopname = newvalue.name
    //     this.storecountdata[4].value= newvalue.shopid;
    //   }
    // },
    methods: {
      open(url) {
      this.$confirm("下载模板", "提示", {
        confirmButtonText: "下载",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          this.$refs.aclick.click();
          this.$message({
            type: "success",
            message: "正在下载!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },
    //查找所有门店列表方法
        getshoplist(qs,cb){
            rejecthttp(false, 'get', "/manage/shop/getshoplist",{appid:188},this,(doc)=>{
                if (doc.data.Code != "MSGKEY_OK") {
                    } else {
                    console.log(doc)
                    this.shoplist = doc.data.data
                    let c = []
                    this.shoplist.forEach(item => {
                        c.push({ shopid: item.shopMain.shopid, name: item.shopMain.name })
                    })
                    this.myshoplist = c
                    console.log('this.shoplist',this.shoplist)
                    console.log('this.myshoplist',this.myshoplist)
                    console.log(c)
                    console.log(typeof cb)
                    let h=new Promise((resolve) => {
                        resolve()
                        // cb(c)/

                    })
                    h.then(i=>{
                        if(cb){
                            cb(c)
                        }else{
                            this.refresh();

                        }
                    })
                        doc.data.data.forEach(item=>{
                            this.hashidtoname[item.shopMain.shopid] = item.shopMain.name
                        })
                    }
            })
        },
           handleSelect(item) {
            console.log('itemselect',item);
            this.shopname = item.name;
            this.storecountdata[4].value= item.shopid;
        },
        handleIconClick(ev) {
            console.log('click',ev);
        },
    //员工编号检验
    myFunction1() {
            rejecthttp(
                false,
                "get",
                "/manage/staff/getstaffbyworkno",
                {
                    appid: 188,
                    workno:this.storecountdata[3].value
                },
                this,
                (doc) => {
                    if (doc.data.Code != "MSGKEY_OK") {
                        // this.myFunction2(),

                            // 被占用的情况
                        this.showtip1 = true; //显示员工编号被占用提示消息
                        console.log(doc);
                        this.changeForm.name = doc.data.data.name;
                        this.changeForm.staffid = doc.data.data.staffId;
                    } else {
                        // this.myFunction2(),
                        this.showtip1 = false; //关闭提示消息
                        console.log(doc);
                        console.log('员工编号被没有暂用')
                    }
                }
            );

        },
        //手机号检验
        myFunction2(){
            // 手机号正则判断
                rejecthttp(
                    false,
                    "get",
                    "/manage/staff/getstaffbymoblie",
                    {
                        appid: 188,
                        moblie: this.storecountdata[5].value + ''
                    },
                    this,
                    (doc) => {
                        if (doc.data.Code != "MSGKEY_OK") {
                            //被占用的情况
                            this.showtip2 = true;  //显示手机号提示消息
                            console.log(doc.data.data);
                            this.changeForm.staffid = doc.data.data.staffId;
                            this.changeForm.name = doc.data.data.name;
                        } else {
                            this.showtip2 = false;  //关闭提示消息
                            console.log('手机号被没有暂用')
                        }
                    }
                );
             },
             //查看
              pushnew(){
           rejecthttp(
                false,
                "get",
                "/manage/staff/getstaffinfo",
                {
                    appid: 188,
                    staffid:this.changeForm.staffid,
                },
                this,
                (doc) => {
                    if (doc.data.Code != "MSGKEY_OK") {
                    } else {
                      this.$message({
                        type:'success',
                        message:'查看重复'
                        })
                      //  pushdata(doc.data.exData.datas)
                      this.showtip1=false
                      this.showtip2=false
                      let row = doc.data
                      console.log(row)
                      console.log(this.storecountdata[0].value)
                      this.storecountdata[0].value=row.data.appid
                      this.storecountdata[1].value=row.data.staffid
                      this.storecountdata[2].value=row.data.name
                      this.storecountdata[3].value=row.data.workno
                      this.storecountdata[4].value=row.data.currentshopid
                      this.storecountdata[5].value=row.data.mobile
                      this.storecountdata[6].value=row.data.position
                      this.storecountdata[7].value=row.data.state
                      console.log(this.storecountdata)
                      this.coordinatable = row.shopCoordinate
                      this.showmodal = true
                    }
                }
            );
        },
    // 下载导出模板
    downTemplate(){
      // /manage/shop/exportshoplisttemplate
      this.url="/static/shopExportTemplate.csv"
      // this.url="/manage/shop/exportshoplisttemplate"

      // window.open('/static/shopExportTemplate.csv')
      console.log(11111111111)
      // window.$refs.aclick.click();

       this.open();
    },
      paginationChange(pagesize, page, name) {
      console.log(pagesize, page)
      this.sendData.pageConfig.page =
        page != -1 ? page : this.sendData.pageConfig.page;
      this.sendData.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize;
      this.getdata();
    },
    // 排序的回调
    filterFunc(config) {
      this.sendData.pageConfig.page = 1;
      this.sendData.sortConfig.order = config.order;
      this.sendData.sortConfig.prop = config.prop;
      this.getdata();
    },
      datashowtrans(item) {
        console.log(item)
        if (item.value !== undefined) {

          if (item.key == 'createdate' || item.key == 'editdate') {
            return setdate(item.value)

          }
          if (item.key == 'createid' || item.key == 'editid') {
            return idtoname(item.value)

          }
          return item.value
        } else {
          return
        }
      },
      deleterow(row) {
        confirmmy(this, {
          title: '此操作将删除该数据, 是否继续?',
          contitle: '删除成功!',
          cancletitle: '已取消删除',
          conback: () => {
            rejecthttp(false, 'get', "/manage/shop/delshop", {
              appid: 188,
              shopid: row.shopMain.shopid
            }, this, (doc) => {
              changeflagCLOSED(doc, 1, this)
              if (doc.data.Code == "MSGKEY_OK") {
                console.log(doc.data);
                this.refresh()
              }
            })
          },
        })
      },
      editTarget(row, f) {
        this.isInit = false
        this.isEditMode = f
        this.isEditMode2 = true
        console.log(row)
        console.log(row.staffid)

           rejecthttp(
                false,
                "get",
                "/manage/staff/getstaffinfo",
                {
                    appid: 188,
                    staffid: row.staffid,
                },
                this,
                (doc) => {
                    if (doc.data.Code != "MSGKEY_OK") {
                    } else {
                      let row = doc.data
                      console.log(row)
                      console.log(this.storecountdata[0].value)
                      this.storecountdata[0].value=row.data.appid
                      this.storecountdata[1].value=row.data.staffid
                      this.storecountdata[2].value=row.data.name
                      this.storecountdata[3].value=row.data.workno
                      this.storecountdata[4].value=row.data.currentshopid
                      this.storecountdata[5].value=row.data.mobile
                      this.storecountdata[6].value=row.data.position
                      this.storecountdata[7].value=row.data.state
                      console.log(this.storecountdata)
                      this.coordinatable = row.shopCoordinate
                      this.showmodal = true

                      this.shopname = this.hashidtoname[row.data.currentshopid];
                    }
                }
            );
      },

      coredata({ appid = 188, shopid = 0, coordinatex = '0', coordinatey = '0', coordinatemaptype = 0, createid = 0, createdate = 0, editid = 0, editdate = 0 }) {
        // 不是第一次创建时使用
        if (!this.isInit) {
          shopid = undefined
        }
        let c = {
          appid,
          shopid,
          coordinatex,
          coordinatey,
          coordinatemaptype,
          createid,
          createdate,
          editid,
          editdate
        }
        // 更新初始值
        for (let i = 0; i < this.coordinaarr.length; i++) {
          let rab = this.coordinaarr[i]
          rab.value = c[rab.key]
        }
        return function() {
          for (let i = 0; i < this.coordinaarr.length; i++) {
            let rab = this.coordinaarr[i]
            try {
              if (rab.key == 'coordinatex' || rab.key == 'coordinatey') {
                c[rab.key] = rab.value - 0
                continue
              }
            } catch (e) {
              confirmmy(that, {
                title: '经纬度不能输入字符',
                iscancel: false,
                isprop: false
              })
            }

            c[rab.key] = rab.value
          }
          return c
        }
      },
      editrewardTarget(scope) {
        console.log(scope)
        this.showmodal2 = true
        this.coortableindex = scope.$index
        this.funccoor = this.coredata(scope.row)
      },
      deleterewardrow(i) {
        this.coortableindex = i
        confirmmy(this, {
          title: '此操作将删除该数据, 是否继续?',
          contitle: '删除成功!',
          cancletitle: '已取消删除',
          conback: () => {
            this.coordinatable.splice(i, 1)
          },
        })
        this.coortableindex = -1
        console.log(i)
      },
      int() {},
      cancel() {
        this.showmodal = false
        this.isEditMode = false
        this.isInit = false
        this.showtip1 = false
        this.showtip2 = false
        this.shopname =''
      },
      dosave() {

        let c = {}
        for (let i = 0; i < this.storecountdata.length; i++) {
          let val = this.storecountdata[i]
          if (val.check) {
            if (!val.check.rule.test(val.value) && val.value) {
              confirmmy(this, {
                title: '手机格式不正确',
                iscancel: false,
                isprop: false
              })
              return
            }
          }
          //  用户名正则验证
          //  if (val.checkname) {
          //   if (!val.checkname.rule.test(val.value) && val.value) {
          //     confirmmy(this, {
          //       title: '用户名不正确',
          //       iscancel: false,
          //       isprop: false
          //     })
          //     return
          //   }
          // }
          if (val.checkworkNo) {
            if (!val.checkworkNo.rule.test(val.value) && val.value) {
              confirmmy(this, {
                title: '员工编号格式不正确(字母数字)',
                iscancel: false,
                isprop: false
              })
              return
            }
          }
          c[val.key] = val.value
        }
        this.showmodal = false
        this.isEditMode = false
        this.showtip1 = false
        this.showtip2 = false
        this.shopname =''
        if (this.isInit) {
          this.save(c)

        } else {
          this.update(c)
        }
        this.isInit = false

      },
      save(v) {
        console.log(v)
           if (!v.name) {
              confirmmy(this, {
                title: '姓名不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }else{
             v.name = v.name.trim();
            }
            if (!v.workNo) {
              confirmmy(this, {
                title: '员工编号不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }
            if (!v.mobile) {
              confirmmy(this, {
                title: '手机号不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }
            if (!v.position) {
              confirmmy(this, {
                title: '职位不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }
            if(v.state!=0&&v.state!=1&&v.state!=2){
               confirmmy(this, {
                title: '员工状态不能为空',
                iscancel: false,
                isprop: false
              })
              return

            }

        rejecthttp(false, 'post', "/manage/staff/addstaffinfo", v, this, (doc) => {
          changeflagCLOSED(doc, 1, this)
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.refresh()
          }
          // else{
          //   confirmmy(this, {
          //       title: doc.data.Message,
          //       iscancel: false,
          //       isprop: false
          //     })
          // }
        })
      },
      update(v) {
            if (!v.name) {
              confirmmy(this, {
                title: '姓名不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }
              if (!v.workNo) {
              confirmmy(this, {
                title: '员工编号不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }
             if (!v.mobile) {
              confirmmy(this, {
                title: '手机号不能为空',
                iscancel: false,
                isprop: false
              })
              return
            }
        let sendd = {
          appid:188,
          currentshopid:this.storecountdata[4].value,
          mobile: this.storecountdata[5].value,
          name: this.storecountdata[2].value,
          position: this.storecountdata[6].value,
          staffid: this.storecountdata[1].value,
          state: this.storecountdata[7].value,
          workno:this.storecountdata[3].value
        }
        rejecthttp(false, 'post', "/manage/staff/updatestaffinfo", sendd, this, (doc) => {
          changeflagCLOSED(doc, 1, this)
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.refresh()
          }
        })
      },
       getDisplayworkstatus(bool) {
      return commonUtil.getDisplayworkstatus(bool);
    },
    getDisplaystate(bool) {
      return commonUtil.getDisplaystate(bool);
    },
    getposition(bool) {
      return commonUtil.getposition(bool);
    },
      createTarget() {
        this.showmodal = true
        this.isEditMode = true
        this.isInit = true
        for (let i = 0; i < this.storecountdata.length; i++) {
          let c = this.storecountdata[i]
          if (c.type != 15) {
            c.value = undefined
          }
        }
        this.coordinatable=[]
        this.funccoor = this.coredata({})
      },
      refresh() {
        this.getdata()
      },
       clear(){
        this.sendData.filterConfig.mobile=null
        this.sendData.filterConfig.workNo=null
        this.sendData.filterConfig.name=null
        this.sendData.pageConfig.page=1
        // this.sendData=JSON.parse(JSON.stringify(this.sendDataCopy))
        this.getdata()
      },
      getdata() {
        rejecthttp(false, 'post', "/manage/staff/getstafflist", this.sendData, this, (doc) => {
            changeflagCLOSED(doc, 0, this)
        if (doc.data.Code == "MSGKEY_OK") {
          console.log(doc.data);
          this.sendData.pageConfig.total = doc.data.exData.datas

          this.articleList = doc.data.data;
          this.articleList.forEach((any) => {
            any.editdate = commonUtil.formatDate(any.editdate);
          });
        }
      });
      },
      // 删除员工按钮
    deleteTarget() {
      console.log(this.targetRow)
      rejecthttp(
        true,
        "post",
        "/manage/staff/deletestaff",
        {
          first: 188,
          second: this.targetRow.staffid,
        },
        this,
        (doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,

            });
          } else {
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          }
          this.deleteDialogVisible = false;
          this.refresh();
        }
      );
    },
      getStateName(state) {
      return commonUtil.getStateName(state);
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
    },
    mounted() {
      // this.getdata()
      this.$nextTick(function() {
        if (this.$refs.table.$el !== "undefined")
          this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

        // 监听窗口大小变化
        let self = this;
        window.onresize = function() {
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 195;
        };
      });
    },
    created() {
    this.getshoplist();
    this.refresh();
  },

  }
</script>

<style scoped>
  .footer {
    margin-top: 10px;
    text-align: right;
  }

  .readonly {
    background: #F5F7FA;
    display: block;
    color: #888;
    height: 20px;
    line-height: 20px;
    padding-left: 15px;
    user-select: text !important;
    ;
  }
  /* 自定义Input模板 */
    .grid-content .content-margin.my-autocomplete .li {
             line-height: normal;
             padding: 7px;
        }
                   .grid-content .content-margin.my-autocomplete .li .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
                   .grid-content .content-margin.my-autocomplete .li .addr {
            font-size: 10px;
            color: #9f9c9c;
        }

                   .grid-content .content-margin .my-autocomplete .li .highlighted .addr {
            color: #ddd;
        }
        .el-table /deep/ td{
    user-select: text !important;;
  }
</style>


// WEBPACK FOOTER //
// src/pages/employee/employeeList.vue